"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityNotificationCms = void 0;
var EligibilityNotificationCms = /** @class */ (function () {
    function EligibilityNotificationCms() {
        this.buttonTxt = 'Check my number';
        this.numberTransferFailureErrTxt = 'This number can\'t be transferred.';
        this.numberTransferSuccessMsgLabel = 'Yes! This number can be transferred.';
        this.numberTransferAlreadyAssignedFailureErrTxt = "You've already assigned this number to a line.";
        this.alreadyInProcessErrMessage = "Looks like a transfer request is already in progress for this number.";
        this.alreadyWithATTErrMessage = "This number is already an AT&T number. If you're not transferring a number from another carrier,\n    you'll need to get a new number.";
    }
    return EligibilityNotificationCms;
}());
exports.EligibilityNotificationCms = EligibilityNotificationCms;
//# sourceMappingURL=EligibilityNotification.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/EligibilityNotification/EligibilityNotification.cms.js
// module id = 950
// module chunks = 8